module.exports = __webpack_public_path__ + "static/media/ic_empowered_green.645ef48a.svg";